import { IconContentTrash } from '@doltech/icons/IconContentTrash';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../colors-v2';

const DELETE_BUTTON_SIZE = 40;

const ButtonMain = styled.button`
  position: absolute;
  bottom: -${DELETE_BUTTON_SIZE + 8}px;
  left: calc(50% - ${DELETE_BUTTON_SIZE / 2}px);
  display: grid;
  place-items: center;
  width: ${DELETE_BUTTON_SIZE}px;
  height: ${DELETE_BUTTON_SIZE}px;
  min-width: ${DELETE_BUTTON_SIZE}px;
  min-height: ${DELETE_BUTTON_SIZE}px;
  background-color: ${colorsV2.white100};
  cursor: pointer;
  border: 1px solid ${colorsV2.black10};
  box-shadow: 0 16px 24px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.04),
    0 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  padding: 8px;
  font-size: 24px;
  color: ${colorsV2.black100};
  line-height: 0;
  transition: all 0.2s ease;

  opacity: 0;
  pointer-events: none;
  z-index: -1;
  transform: translateY(${DELETE_BUTTON_SIZE / 2}px);

  &.visible {
    opacity: 1;
    pointer-events: auto;
    z-index: 10;
    transform: translateY(0);
  }

  &:hover {
    filter: brightness(90%);
  }
  &:active {
    transform: scale(0.96);
  }
`;

export interface DeleteElementButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  visible: boolean;
}

export const DeleteElementButton = (props: DeleteElementButtonProps) => {
  const { className, visible, ...rest } = props;
  return (
    <ButtonMain
      contentEditable={false}
      type="button"
      className={cl(className, 'delete-button', { visible })}
      {...rest}
    >
      <IconContentTrash />
    </ButtonMain>
  );
};
